"use client";

import * as React from "react";
import LazySidePanel from "components/Explore/sidepanel/LazySidePanel";

type ExploreSidePanelV2Props = React.ComponentProps<typeof LazySidePanel>;

/** Wrapper v2 del side panel desktop de Explore. */
export function ExploreSidePanelV2(props: ExploreSidePanelV2Props) {
  return <LazySidePanel {...props} />;
}
